/** @format */
const emsNameShippingInformation = 'shipping-information';
const emsNameItemAvailability = 'item-availability';
const todaySVG = 'assets/image/today.svg';
export const DEFAULT_SHIPPING_MESSAGES = [
	{
		analyticsModalName: 'Standard Shipping Details',
		emsName: emsNameShippingInformation,
		image: '',
		imageClass: '',
		innerHtml: '',
		message: 'Standard Ground Shipping Available',
		order: 1,
		show: false,
		showImage: false,
		subMessage: '',
		type: 'Standard'
	},
	{
		analyticsModalName: 'Pre Sale Details',
		emsName: emsNameItemAvailability,
		image: todaySVG,
		imageClass: '',
		innerHtml: '',
		message: 'Pre-Order Product',
		order: 2,
		show: false,
		showImage: true,
		subMessage: '',
		type: 'PreOrder'
	},
	{
		analyticsModalName: 'Sale and Shipping Restrictions',
		emsName: 'sale-and-shipping-restrictions',
		image: 'assets/image/not-interested.svg',
		imageClass: 'red-image',
		innerHtml: '',
		message: 'Sale & Shipping Restrictions.',
		order: 3,
		show: false,
		showImage: true,
		subMessage: '',
		type: 'Restriction'
	},
	{
		analyticsModalName: 'Oversized Shipping Charges',
		emsName: emsNameShippingInformation,
		image: 'assets/image/monetization.svg',
		imageClass: '',
		innerHtml: '',
		message: 'Oversized Shipping Charges Apply.',
		order: 4,
		show: false,
		showImage: true,
		subMessage: '',
		type: 'OP'
	},
	{
		analyticsModalName: 'Lead Time',
		emsName: emsNameItemAvailability,
		image: todaySVG,
		imageClass: '',
		innerHtml: '',
		message: '',
		order: 5,
		show: false,
		showImage: true,
		subMessage: '',
		type: 'LeadTime'
	},
	{
		analyticsModalName: 'Scheduled Delivery',
		emsName: emsNameShippingInformation,
		image: todaySVG,
		imageClass: '',
		innerHtml: '',
		message: 'Requires scheduled delivery. Assembly options may be available.',
		order: 6,
		show: false,
		showImage: true,
		subMessage: '',
		type: 'LTL'
	}
];
